import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { InstallPrompt } from "./components/InstallPrompt";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import { isPremium, setPremium } from "./lib/usageLimit";

function App() {
  const [premium, setPremiumState] = useState(false);

  // Listen for premium state changes (so multiple components stay in sync)
  const refreshPremium = useCallback(() => {
    setPremiumState(isPremium());
  }, []);

  useEffect(() => {
    // Check URL param for activation (e.g. redirect from Digistore24 thank-you page)
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get("activate") === "premium") {
        setPremium(true);
        toast.success("Premium freigeschaltet", {
          description:
            "Unbegrenzte Generierungen sind aktiv. Die Abbuchung erfolgt durch Digistore24.com.",
          duration: 8000,
        });
        // Clean URL
        const cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, "", cleanUrl);
      }
    } catch {
      /* ignore */
    }
    refreshPremium();

    // React to manual changes (other tabs / console)
    const onStorage = () => refreshPremium();
    window.addEventListener("storage", onStorage);
    window.addEventListener("promptkiste:premium-changed", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("promptkiste:premium-changed", onStorage);
    };
  }, [refreshPremium]);

  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-[#050505] text-white">
        <Header premium={premium} />
        <Routes>
          <Route path="/" element={<Home premium={premium} />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="*" element={<Home premium={premium} />} />
        </Routes>
        <Footer />
        <InstallPrompt />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0F1014",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#fff",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
